module.exports = __webpack_public_path__ + "media/images/lp/industries/feature-01-08cecaba4665ecaf26136c9768a29bb0.png";